import React from 'react';
import styled from 'styled-components';
import {
  ScanOutlined,
  SearchOutlined,
  StockOutlined,
  TableOutlined,
  DeleteFilled,
  PlusCircleOutlined
} from '@ant-design/icons';
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import {
  Row,
  Col,
  Spin,
  Button,
  List,
  Tabs,
  Popover,
  Input,
  Table,
  Divider,
  Modal,
  Select,
  Card,
  InputNumber,
  Typography,
  Switch,
  AutoComplete,
  Badge,
  DatePicker
} from 'antd';
import moment from 'moment';
import { Link } from 'react-router-dom';
import Notify from 'src/components/meta/Notification';
import noImage from 'src/static/icons/carImageUpload/no-image-available.svg';
import Countdown from 'react-countdown-now';
import Highlighter from 'react-highlight-words';
import pdfMake from 'pdfmake/build/pdfmake';
import vfsFonts from 'pdfmake/build/vfs_fonts';
import prepDefinition from 'src/components/meta/PdfDefinition2';
import prepDefinition2 from 'src/components/meta/PdfDefinition3';
import ReactExport from 'react-export-excel';
import { Excel } from 'antd-table-saveas-excel';
const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
const { Column, ColumnGroup } = Table;
const { TextArea } = Input;
const FormItem = Form.Item;
const Option = Select.Option;
const { Text } = Typography;
const numeral = require('numeral');
const { TabPane } = Tabs;
const onChange = (date, dateString) => {
  console.log(date, dateString);
};
const { RangePicker } = DatePicker;
const dateFormat = 'YYYY/MM/DD';
const StyledSelect = styled(Select)`
  .ant-select-selector {
    width: 100%;
    height: 55px !important;
    border-radius: 0.5em !important;
    padding-top: 11px !important;
  }
  .ant-select:not(.ant-select-customize-input) .ant-select-selector {
    position: relative;
    color: red !important;
    background-color: #ffffff;
    border: 1px solid #e9e9e9;
    border-radius: 2px;
    transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  }
  .ant-select-selection-placeholder {
    color: rgba(0, 0, 0, 0.45) !important;
  }
  .ant-select-show-search.ant-select:not(.ant-select-customize-input)
    .ant-select-selector
    input {
    cursor: auto;
    padding-top: 1.2em !important;
  }
`;
const StyledDatePicker = styled(RangePicker)`
z-index: 9999;
  padding-left: 1.2em !important;
  height: 45px !important;

    box-shadow:none !important;
  background-color: white!important;
  background-image: none;
  border: none;
  border: 0px solid black !important;
  border: 1px solid lightgrey !important;
  border-radius: 0px;
  color: black!important;
  //box-shadow: rgba(0, 0, 0, 0.11) 2px 8px 13px 5px !important;
  
  :placeholder {
    color: lightgrey !important;
  }
  :hover {
    border-color: red !important;

    box-shadow:none !important;
}
  :active{
    border-color: red !important;
   
     box-shadow:none !important;
   
  }
  :focus{
    border-color: red !important;
    
     box-shadow:none !important;
   
  }
  }
`;
const StyledTable = styled(Table)`
  .ant-table-thead > tr > th {
    color: #8898aa;
    background: #eef5ff !important;
  }
  .ant-table-tbody > tr > td {
    border-bottom: 1px solid #f0f0f0;
    transition: background 0.3s;

    font-weight: 500;
    color: #525f7f;
    font-size: 15px;
  }
`;
const StyledTabs = styled(Tabs)`
  .ant-tabs-top > .ant-tabs-nav::before,
  .ant-tabs-bottom > .ant-tabs-nav::before,
  .ant-tabs-top > div > .ant-tabs-nav::before,
  .ant-tabs-bottom > div > .ant-tabs-nav::before {
    position: absolute;
    right: 0;
    left: 0;
    border-bottom: 0px solid #f0f0f0 !important;
    content: '';
  }
`;
const Selection = styled(Select)`
  .ant-select-selection {
    border: 1px solid #bdb2b2;
    height: 45px;
    font-size: 12px;
  }
  .ant-select-selection__placeholder {
    top: 21px;
  }
  .ant-select-selection__rendered {
    height: 44px;
  }
  .ant-select-selection-selected-value {
    position: relative;
    top: 6px;
  }
`;
const StyledBadge = styled(Badge)`
  .ant-badge-status-dot {
    height: 0.6em !important;
    width: 0.6em !important;
  }
`;

const currentRigColumns = [
  {
    title: 'Serial Nr.',
    dataIndex: 'toolSerial',
    key: 'toolSerial',
    width: 100
  },
  {
    title: 'Stock Nr',
    dataIndex: 'serial',
    key: 'serial',
    width: 100
  },
  {
    title: 'Tool Type',
    dataIndex: 'size',
    key: 'size',
    width: 80
  },
  {
    title: 'Description',
    dataIndex: 'description',
    key: 'description',
    width: 160
  },
  {
    title: 'Status',
    dataIndex: 'status',
    key: 'status',
    width: 85,
    render: status => {
      const formattedPrice = status === undefined ? 'None' : status;
      return <span>{formattedPrice}</span>;
    }
  },
  {
    title: 'Date',
    dataIndex: 'date',
    key: 'date',
    width: 135,
    render: date => (date ? moment(date).format('YYYY-MM-DD HH:mm:ss') : '') // ← return blank instead of “Invalid date”
  },
  {
    title: 'Price',
    dataIndex: 'price',
    key: 'price',
    width: 95,
    render: price => {
      const formattedPrice = parseFloat(price).toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
      return <span>{formattedPrice}</span>;
    }
  }
];
const data = [];

class StockFormClass extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,

      itemCodes: [],
      removedMeters: null,
      newBitStatus: null,
      replaceSize: null,
      replaceDesc: null,
      replaceStatus: null,
      replaceLastUser: null,
      selectedBit: null,
      replaceSerial: null,
      visible: false
    };
  }

  render() {
    let { selectedBit } = this.state;

    return (
      <div style={{ maxWidth: '50em', margin: 'auto', marginTop: '2em' }}>
        <span style={{ fontWeight: 750, fontSize: 25 }}>Add New Rig</span>{' '}
        <Form>
          <Row style={{ marginTop: '2em', marginBottom: '1em' }}>
            <Col span={11}>
              <FormItem label={<span>Rig Number</span>}>
                {this.props.form.getFieldDecorator('currentRig', {
                  rules: [
                    {
                      required: true,
                      message: 'Rig Number required'
                    }
                  ],
                  initialValue: this.props.editStock
                    ? this.props.editStock.currentRig
                    : ''
                })(
                  <Input
                    // disabled
                    type={'number'}
                  />
                )}
              </FormItem>
            </Col>
            <Col span={2} />
            <Col span={11}>
              <FormItem label={<span>Site Access</span>}>
                {this.props.form.getFieldDecorator('access', {
                  rules: [
                    {
                      required: true,
                      message: 'Access required'
                    }
                  ],
                  initialValue: this.props.editBits
                    ? this.props.editStock.access
                    : []
                })(
                  <Select>
                    {this.props.sites.map(site => (
                      <Option key={site._id} value={site._id}>
                        {site.name}
                      </Option>
                    ))}
                  </Select>
                )}
              </FormItem>
            </Col>
          </Row>
          <Button
            type="primary"
            shape="round"
            onClick={this.props.onOk}
            size="large"
            style={{
              float: 'right',
              fontSize: '14px',
              width: '7em',
              height: '3em',
              //height: "3em",
              marginLeft: '0.7em'
            }}
          >
            Save
          </Button>
          <Button
            shape="round"
            onClick={this.props.onCancel}
            style={{
              fontSize: '14px',
              width: '7em',
              height: '3em',
              border: '1px solid #EEEFF0',
              backgroundColor: '#EEEFF0',
              float: 'right'
            }}
          >
            Cancel
          </Button>
        </Form>
      </div>
    );
  }
}
const StockForm = Form.create()(StockFormClass);

class Stock extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      closed: false,
      filteredInfo: null,
      rejectReason: '',
      jobNumbers: [],
      jobNumber: undefined,
      technician: undefined,
      technicians: [],
      qty: 1,
      qtyError: false,
      itemCodes: [],
      siteSelected:
        this.props.sites.length > 0 && this.props.user.type !== 'admin'
          ? this.props.user.access
          : this.props.user.type === 'admin'
          ? this.props.sites[0]._id
          : 'None',
      rigSelected: 'all',
      pitSelected: 'all',
      startDate: moment().startOf('month'),
      endDate: moment().endOf('month'),
      selectedPitDrilled: 'all',
      totalMetersSum: 0 // Add the totalMetersSum state variable
    };
  }
  updateSignal;
  componentWillMount = () => {
    this.setState({ loading: true });
    this.props
      .findAllStock(this.props.user.access)
      .then(() => {
        let itemCodes = [];
        this.props.stock.forEach(stock => {
          if (stock.itemCode) {
            itemCodes.push(
              'Part: ' + stock.itemCode + ' - Location: ' + stock.location
            );
          }
        });
        this.setState({
          loading: false,
          itemCodes: itemCodes,
          siteSelected:
            this.props.sites.length > 0 && this.props.user.type !== 'admin'
              ? this.props.user.access
              : this.props.user.type === 'admin'
              ? this.props.sites[0]._id
              : 'None',
          rigSelected: 'all',
          pitSelected: 'all',
          selectedPitDrilled: 'all'
        });
      })
      .catch(e => {
        this.setState({ loading: false });
        Notify('error', e);
      });
    this.updateSignal = {
      signal: msg => {
        this.props
          .findAllStock(this.props.user.access)
          .then(() => {
            let itemCodes = [];
            this.props.stock.forEach(stock => {
              if (stock.itemCode) {
                itemCodes.push(
                  'Part: ' + stock.itemCode + ' - Location: ' + stock.location
                );
              }
            });
            this.setState({ loading: false, itemCodes: itemCodes });
          })
          .catch(e => {
            this.setState({ loading: false });
            Notify('error', e);
          });
      }
    };
    window.pubnub.addListener(this.updateSignal);
    window.addEventListener('resize', this.resizeEvent);
    if (window.cordova) {
      document.addEventListener('backbutton', this.handleBack);
    }
  };

  handleBack = () => {
    if (this.state.addStockVisible) {
      this.setState({ addStockVisible: false });
    } else {
      this.props.history.goBack();
    }
  };

  componentWillUnmount = () => {
    window.pubnub.removeListener(this.updateSignal);
    window.removeEventListener('resize', this.resizeEvent);
    if (window.cordova) {
      document.removeEventListener('backbutton', this.handleBack);
    }
  };

  resizeEvent = () => {
    this.setState({ loading: false });
  };
  parseString = string => {
    return parseInt(string.split('R')[1].replace(/,/g, ''));
  };
  formatNumber = number => {
    return 'R' + numeral(number).format('0,0');
  };

  handleSelectStock = e => {
    this.props.setStockDetailsId(e.currentTarget.getAttribute('data'));
    this.props.push('/admin/stockdetails');
  };
  handleSort = (pagination, filters, sorter) => {
    const columnKey = sorter.columnKey;
    const order = sorter.order;
    let stock = this.state.stock;
    if (order === 'ascend') {
      stock.sort((a, b) => parseInt(a[columnKey]) - parseInt(b[columnKey]));
    } else if (order === 'descend') {
      stock.sort((a, b) => parseInt(b[columnKey]) - parseInt(a[columnKey]));
    }
    this.setState({
      filteredInfo: filters,
      sortedInfo: sorter
    });
  };
  handleSearch = (selectedKeys, confirm) => {
    confirm();
    this.setState({ searchText: selectedKeys[0] });
  };

  handleReset = clearFilters => {
    clearFilters();
    this.setState({ searchText: '' });
  };
  handleChange = (pagination, filters, sorter) => {
    console.log('Various parameters', pagination, sorter);
    this.setState({
      filteredInfo: filters,
      sortedInfo: sorter
    });
  };
  clearFilters = () => {
    this.setState({ filteredInfo: null });
  };
  getColumnSearchProps = dataIndex => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={node => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={e =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => this.handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => this.handleSearch(selectedKeys, confirm)}
          icon={<SearchOutlined />}
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button
          onClick={() => this.handleReset(clearFilters)}
          size="small"
          style={{ width: 90 }}
        >
          Reset
        </Button>
      </div>
    ),
    filterIcon: filtered => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        .toString()
        .toLowerCase()
        .includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: visible => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
    render: text =>
      text ? (
        <Highlighter
          highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
          searchWords={[this.state.searchText]}
          autoEscape
          textToHighlight={text.toString()}
        />
      ) : (
        ''
      )
  });
  onAddStock = e => {
    this.setState({ addStockVisible: true, editStock: undefined });
  };
  onEditStock = e => {
    this.setState({ addStockVisible: true, editStock: e });
  };
  onEditStockApprove = stock => {
    this.setState({ loading: true });
    if (stock.status === 'In Request') {
      stock.qty = parseInt(stock.qty) + 1;
    } else if (stock.status === 'Out Request') {
      stock.qty = parseInt(stock.qty) - 1;
    }
    stock.status = 'None';
    this.props
      .addStock(stock)
      .then(() => {
        this.props
          .findAllStock(this.props.user.access)
          .then(() => {
            this.props
              .sendNotification(
                stock.requestId,
                [stock.requestId],
                'Admin has approved one of your requests',
                'adminChanged',
                stock._id,
                false,
                'Beowolf Mining Admin'
              )
              .then(() => {
                this.setState({ loading: false });
                Notify('success', 'Successfully approved request');
              })
              .catch(e => {
                this.setState({ loading: false });
                Notify('error', e);
              });
          })
          .catch(e => {
            this.setState({ loading: false });
            Notify('error', e);
          });
      })
      .catch(e => {
        this.setState({ loading: false });
        Notify('error', e);
      });
  };
  handleAddStock = e => {
    e.preventDefault();
    this.stockForm.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        this.setState({ loading: true });
        if (this.state.editStock) {
          values._id = this.state.editStock._id;
        }
        this.props
          .addStock(values)
          .then(() => {
            this.props
              .findAllStock(this.props.user.access)
              .then(() => {
                if (this.state.editStock) {
                  Notify('success', 'Successfully saved rig');
                } else {
                  Notify('success', 'Successfully added rig');
                }
                this.stockForm.props.form.resetFields();
                let itemCodes = [];
                this.props.stock.forEach(stock => {
                  if (stock.itemCode) {
                    itemCodes.push(
                      'Part: ' +
                        stock.itemCode +
                        ' - Location: ' +
                        stock.location
                    );
                  }
                });
                this.setState({ itemCodes: itemCodes });
                this.setState({
                  loading: false,
                  addStockVisible: false,
                  editStock: undefined
                });
              })
              .catch(e => {
                this.setState({ loading: false });
                Notify('error', e);
              });
          })
          .catch(e => {
            this.setState({ loading: false });
            Notify('error', e);
          });
      }
    });
  };
  onEditStockOutVisible = stock => {
    if (parseInt(stock.qty) === 0) {
      Notify('error', 'There is no stock left');
      return;
    }
    this.setState({
      stockOut: stock,
      outVisible: true
    });
  };
  onEditStockOut = () => {
    let stock = this.state.stockOut;
    if (this.state.qtyError === true || this.state.qty === 0) {
      return;
    }
    if (parseInt(stock.qty) === 0) {
      Notify('error', 'There is no stock left');
      return;
    }
    const id = stock._id;
    let request = {
      qty: this.state.qty,
      jobNumber: this.state.jobNumber,
      stockId: id,
      type: 'Out',
      itemCode: stock.itemCode,
      description: stock.description,
      userName: this.state.userName,
      requisitionNumber: this.state.requisitionNumber,
      approved: true
    };
    this.setState({ loading: true, outVisible: false });
    this.props
      .addRequest(request)
      .then(() => {
        this.props
          .findAllStock(this.props.user.access)
          .then(() => {
            let itemCodes = [];
            this.props.stock.forEach(stock => {
              if (stock.itemCode) {
                itemCodes.push(
                  'Part: ' + stock.itemCode + ' - Location: ' + stock.location
                );
              }
            });
            this.setState({ itemCodes: itemCodes });
            const { vfs } = vfsFonts.pdfMake;
            pdfMake.vfs = vfs;
            let data = Object.assign({}, request);
            prepDefinition(data).then(definition => {
              pdfMake
                .createPdf(definition)
                .download(
                  stock.itemCode +
                    ' ' +
                    moment().format('YYYY-MM-DD') +
                    ' Approved Request.pdf',
                  () => {
                    this.setState({ loading: false, qty: 1, qtyError: false });
                    Notify('success', 'Successfully submitted');
                  }
                );
            });
          })
          .catch(e => {
            this.setState({ loading: false });
            Notify('error', e);
          });
      })
      .catch(e => {
        this.setState({ loading: false });
        Notify('error', e);
      });
  };
  handleEditBatchStockOut = e => {
    e.preventDefault();
    this.requisitionForm.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        for (var i = 0; i < this.requisitionForm.state.parts.length; i++) {
          if (!this.requisitionForm.state.parts[i].addButton) {
            if (!this.requisitionForm.state.parts[i].qty) {
              return;
            }
          }
        }
        this.setState({ loading: true });
        if (this.state.editRequisition) {
          values._id = this.state.editRequisition._id;
        }
        values.parts = this.requisitionForm.state.parts;
        values.type = 'Out';
        values.approved = true;
        this.props
          .addBatchRequest(values)
          .then(() => {
            this.props
              .findAllStock(this.props.user.access)
              .then(() => {
                let itemCodes = [];
                this.props.stock.forEach(stock => {
                  if (stock.itemCode) {
                    itemCodes.push(
                      'Part: ' +
                        stock.itemCode +
                        ' - Location: ' +
                        stock.location
                    );
                  }
                });
                this.setState({ itemCodes: itemCodes });
                const { vfs } = vfsFonts.pdfMake;
                pdfMake.vfs = vfs;
                let data = Object.assign({}, values);
                prepDefinition2(data).then(definition => {
                  pdfMake
                    .createPdf(definition)
                    .download(
                      values.requisitionNumber +
                        ' ' +
                        moment().format('YYYY-MM-DD') +
                        ' Approved Request.pdf',
                      () => {
                        this.setState({
                          loading: false,
                          addBatchVisible: false
                        });
                        Notify('success', 'Successfully submitted');
                      }
                    );
                });
              })
              .catch(e => {
                this.setState({ loading: false });
                Notify('error', e);
              });
          })
          .catch(e => {
            this.setState({ loading: false });
            Notify('error', e);
          });
      }
    });
  };
  handleDeleteStock = e => {
    this.setState({ loading: true, deleteVisible: false });
    const data = this.state.deleteStock;
    this.props
      .deleteStock(data._id)
      .then(() => {
        this.props
          .findAllStock(this.props.user.access)
          .then(() => {
            let itemCodes = [];
            this.props.stock.forEach(stock => {
              if (stock.itemCode) {
                itemCodes.push(
                  'Part: ' + stock.itemCode + ' - Location: ' + stock.location
                );
              }
            });
            this.setState({ loading: false, itemCodes: itemCodes });
            Notify('success', 'Deleted stock', 'Successfully deleted rig.');
          })
          .catch(e => {
            this.setState({ loading: false });
            Notify('error', e);
          });
        this.setState({ loading: false });
      })
      .catch(e => {
        this.setState({ loading: false });
        Notify('error', e);
      });
  };
  handleSearchJob = e => {
    if (e.length > 3) {
      this.props
        .findJobNumbers(e)
        .then(suc => {
          this.setState({
            jobNumbers: suc.jobNumbers
          });
        })
        .catch(e => {
          this.setState({ loading: false });
          Notify('error', e);
        });
    } else {
      this.setState({
        jobNumbers: []
      });
    }
  };
  handleSearchTechnician = e => {
    if (e.length > 3) {
      this.props
        .findTechnicians(e)
        .then(suc => {
          this.setState({
            technicians: suc.technicians
          });
        })
        .catch(e => {
          this.setState({ loading: false });
          Notify('error', e);
        });
    } else {
      this.setState({
        technicians: []
      });
    }
  };
  cancelDelete = e => {
    this.setState({ deleteVisible: false, deleteStock: '' });
  };
  checkQty = e => {
    let setQty = e;
    if (setQty !== '' && setQty !== null) {
      if (this.state.stockOut.qty < setQty) {
        this.setState({
          qty: parseInt(setQty),
          qtyError: true
        });
      } else {
        this.setState({
          qty: parseInt(setQty),
          qtyError: false
        });
      }
    } else {
      this.setState({
        qty: 1,
        qtyError: false
      });
    }
  };
  renderStatus = (status, color) => {
    return (
      <p style={{ margin: 0 }}>
        <StyledBadge color={color} style={{}} />
        {status}
      </p>
    );
  };

  viewRig = rig => {
    this.setState({ currentRig: rig, viewRig: true });
  };

  render() {
    const { stock } = this.props;
    let { sortedInfo, filteredInfo } = this.state;
    filteredInfo = filteredInfo || {};
    let jobOptions = this.state.jobNumbers.map(d => (
      <Option key={d.sysRefNo}>{d.sysRefNo}</Option>
    ));
    let technicianOptions = this.state.technicians.map(d => (
      <Option key={d.username} value={d.name}>
        {d.name + ' - ' + d.username.split('|')[1]}
      </Option>
    ));
    let unRigs = [];
    this.props.stock.forEach(rig => {
      if (
        (rig.access === this.state.siteSelected &&
          rig.currentRig === this.state.rigSelected) ||
        (rig.access === this.state.siteSelected &&
          this.state.rigSelected === 'all')
      ) {
        unRigs.push(rig);
      }
    });

    let rigs = [];
    let unProcessedRigs = JSON.parse(JSON.stringify(unRigs));
    unProcessedRigs.forEach(rig => {
      // for costs:
      if (rig.cost) {
        // 1) filter to only the in-range costs
        const validCosts = rig.cost.filter(cost =>
          moment(cost.date).isBetween(
            this.state.startDate,
            this.state.endDate,
            'day',
            '[]'
          )
        );

        // 2) adjust “Reissued” prices and compute total
        let total = 0;
        validCosts.forEach(c => {
          // make sure price is a number
          const base = parseFloat(c.price) || 0;

          if (c.status === 'Reissued') {
            // flip to negative
            c.price = -Math.abs(base);
          } else if (c.status === 'None') {
            // zero-out None statuses
            c.price = 0;
          } else if (c.status === 'Used') {
            // zero-out None statuses
            c.price = 0;
          } else {
            // leave everything else as its parsed value
            c.price = base;
          }

          total += c.price;
        });

        rig.cost = validCosts;
        rig.totalCost = total;
      }

      // for meterUpdates:
      if (rig.meterUpdates) {
        const validMeters = rig.meterUpdates.filter(mu =>
          moment(mu.date).isBetween(
            this.state.startDate,
            this.state.endDate,
            'day',
            '[]'
          )
        );

        let meterSum = 0;
        validMeters.forEach(mu => {
          meterSum += parseFloat(mu.meters);
        });

        rig.meterUpdates = validMeters;
        rig.totalMeters = meterSum;
      }

      rigs.push(rig);
    });
    let totalCost = 0;
    let totalpitDrilled = 'None';
    let totalCostPerMeter = 0;
    rigs.forEach(rig => {
      if (!rig.totalCost && !rig.totalMeters) {
        rig.totalCost = 0;
        rig.totalMeters = 0;
        rig.totalCostPerMeter = 0;
        rig.pitDrilled = 'None';
      }
      totalCost = totalCost + rig.totalCost;
      totalCostPerMeter = rig.totalCost / rig.totalMeters;
      // totalMeters = totalMeters + rig.totalMeters;
      totalpitDrilled = rig.totalpitDrilled;
    });
    let currentRig;
    let currentRigTotal = 0;
    if (this.state.currentRig) {
      currentRig = rigs.find(rig => rig._id === this.state.currentRig._id);
      currentRigTotal = currentRig && currentRig.totalCost;

      if (currentRig.cost) {
        const filteredData = currentRig.cost.filter((cost, index) => {
          if (
            moment(cost.date).isBetween(
              this.state.startDate,
              this.state.endDate,
              'day',
              '[]'
            )
          ) {
            if (cost.status === 'Reissued') {
              cost.price = -Math.abs(parseFloat(cost.price));
            }

            currentRig.totalCost =
              currentRig.totalCost && currentRig.totalCost !== 'None'
                ? currentRig.totalCost + parseFloat(cost.price)
                : parseFloat(cost.price);

            return true;
          } else {
            return false;
          }
        });

        currentRig.cost = filteredData;
      }
    }
    // 1. Safely grab the cost array (or empty array if missing)
    const costData = Array.isArray(currentRig?.cost) ? currentRig.cost : [];

    // 2. Then clone if you need to avoid mutating the original array
    //    (filter already returns a new array, so this step is optional)
    const costDataClone = [...costData];

    // 3. Finally sort your clean list
    costDataClone.sort((a, b) => {
      if (a.toolSerial && b.toolSerial) {
        return a.toolSerial.localeCompare(b.toolSerial);
      }
      if (a.toolSerial) return -1;
      if (b.toolSerial) return 1;
      return 0;
    });
    const invoiceTotal = rigs.reduce(
      (sum, rig) => sum + (Number(rig.totalCost) || 0),
      0
    );
    const totalMeters = rigs.reduce(
      (sum, rig) => sum + (Number(rig.totalMeters) || 0),
      0
    );
    const costPerMeter = totalMeters > 0 ? invoiceTotal / totalMeters : 0;
    const rigNumbers = [...new Set(rigs.map(rig => rig.currentRig))];
    const pitNumbers = [...new Set(rigs.map(rig => rig.pitDrilled))];
    // let totalMetersSum = 0;

    const totalsRow = {
      currentRig: 'Totals',
      totalMeters: totalMeters,
      // if your Excel lib will call your column renderers for you, you can leave numbers;
      // otherwise pre-format them as strings here:
      totalCost: invoiceTotal,
      // if you want the Cost / Meter column in Excel:
      totalCostPerMeter: parseFloat(costPerMeter.toFixed(2))
    };

    const columns = [
      {
        title: 'Rig Number',
        dataIndex: 'currentRig',
        key: 'currentRig'
      },
      {
        title: 'Meters',
        dataIndex: 'totalMeters',
        key: 'totalMeters',
        width: 100
      },
      {
        title: 'Cost P/Meter',
        dataIndex: 'totalCost',
        key: 'totalCost',
        width: 95,
        render: (totalCost, record) => {
          // modified parameter name to 'record'
          const formattedPrice = parseFloat(
            record.totalCost / record.totalMeters
          ).toLocaleString('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          });
          return <span>{formattedPrice}</span>;
        }
      },
      {
        title: 'Rig Cost',
        dataIndex: 'totalCost',
        key: 'totalCost',
        width: 100,
        render: totalCost => {
          const formattedPrice = parseFloat(totalCost).toLocaleString('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          });
          return <span>{formattedPrice}</span>;
        }
      }
    ];
    const pitsColumns = [
      {
        title: 'Rig Number',
        dataIndex: 'currentRig',
        key: 'currentRig'
      },
      {
        title: 'Pit Drilled',
        dataIndex: 'totalpitDrilled',
        key: 'totalpitDrilled',
        width: 100
      },
      {
        title: 'Meters',
        dataIndex: 'totalMeters',
        key: 'totalMeters',
        width: 100
      },
      {
        title: 'Date',
        dataIndex: 'date',
        key: 'date',
        width: 135,
        render: (date, record) => {
          // modified parameter name to 'record'
          const formattedDate = moment(record.date).format(
            'YYYY-MM-DD HH:mm:ss'
          );
          return formattedDate;
        }
      }
    ];
    if (!this.state.viewRig) {
      return (
        <div>
          <div style={{ maxWidth: '90em', margin: 'auto' }}>
            <Spin spinning={this.state.loading}>
              {/* {this.state.addStockVisible ? ( */}
              <Row
                style={{
                  background: 'white',
                  borderRadius: 5,
                  // marginTop: 20,
                  display: this.state.addStockVisible ? 'flex' : 'none'
                }}
                type="flex"
                justify="space-around"
                align="middle"
              >
                <Col style={{ padding: 20 }} span={20}>
                  <StockForm
                    editStock={this.state.editStock}
                    sites={this.props.sites}
                    wrappedComponentRef={form => (this.stockForm = form)}
                    onOk={this.handleAddStock}
                    onCancel={e => this.setState({ addStockVisible: false })}
                    okText={this.state.editStock ? 'Save' : 'Add Stock'}
                  />
                </Col>
              </Row>

              <Row
                type="flex"
                justify="start"
                align="middle"
                style={{
                  textAlign: 'center',
                  margin: 'auto',
                  maxWidth: '90em',
                  display: !this.state.addStockVisible ? '' : 'none'
                }}
              >
                <Col xs={24} md={12} style={{ textAlign: 'left' }}>
                  <span style={{ fontWeight: 750, fontSize: 30 }}>
                    Rig Management -
                  </span>{' '}
                  <StyledSelect
                    value={this.state.siteSelected}
                    onChange={e => {
                      this.setState({ siteSelected: e });
                    }}
                    defaultValue={this.state.siteSelected}
                    style={{ height: 55, marginLeft: '1em', minWidth: '10em' }}
                  >
                    {this.props.sites.map(site =>
                      site._id === this.props.user.access ? (
                        <Option value={site._id}>{site.name}</Option>
                      ) : this.props.user.type === 'admin' ? (
                        <Option value={site._id}>{site.name}</Option>
                      ) : null
                    )}
                  </StyledSelect>
                  <StyledSelect
                    value={this.state.rigSelected}
                    onChange={e => {
                      this.setState({ rigSelected: e });
                    }}
                    defaultValue={this.state.rigSelected}
                    style={{ height: 55, marginLeft: '1em', minWidth: '6em' }}
                  >
                    {' '}
                    <Option value="all">All Rigs</Option>{' '}
                    {rigNumbers.map(pitNumber => (
                      <Option value={pitNumber}>{pitNumber}</Option>
                    ))}
                  </StyledSelect>
                  <br /> <br />
                </Col>

                <Col
                  xs={24}
                  md={12}
                  style={{ float: 'right', textAlign: 'right' }}
                >
                  {this.props.user.type === 'admin' ? (
                    <Button
                      type="primary"
                      shape="round"
                      onClick={this.onAddStock}
                      icon={<PlusCircleOutlined style={{ fontSize: '110%' }} />}
                      size="large"
                      style={{
                        marginRight: '0.5em',
                        height: '3em',
                        width: '9em'
                      }}
                    >
                      Add Rig
                    </Button>
                  ) : null}
                  <Link to="/admin/pexrequests">
                    <Button
                      type="primary"
                      shape="round"
                      size="large"
                      style={{
                        backgroundColor: 'transparent',
                        color: '#EC8144',
                        border: '1px solid #EC8144',
                        marginRight: '0.5em',
                        height: '3em',
                        width: '6em'
                      }}
                    >
                      Cost
                    </Button>
                  </Link>
                  <Link to="/admin/pexunit">
                    <Button
                      type="primary"
                      shape="round"
                      // onClick={this.onAddStock}
                      size="large"
                      style={{
                        backgroundColor: 'transparent',
                        color: 'red',
                        border: '1px solid red',
                        marginRight: '0.5em',
                        height: '3em',
                        width: '7em'
                      }}
                    >
                      Damages
                    </Button>
                  </Link>
                </Col>

                <Col
                  xs={24}
                  md={24}
                  style={{
                    textAlign: 'right',
                    marginTop: '-1em',
                    marginBottom: '-6em',
                    zIndex: 999,
                    display:
                      !this.state.addStockVisible && !this.state.addBatchVisible
                        ? ''
                        : 'none'
                  }}
                >
                  <Tabs
                    defaultActiveKey="1"
                    style={{
                      marginTop: 20,
                      display:
                        !this.state.addStockVisible &&
                        !this.state.addBatchVisible
                          ? ''
                          : 'none'
                    }}
                  >
                    <TabPane tab="Rigs" key="1">
                      <Row
                        style={{
                          background: 'white',
                          borderRadius: 5,
                          marginTop: 0,
                          display:
                            !this.state.addStockVisible &&
                            !this.state.addBatchVisible
                              ? 'flex'
                              : 'none'
                        }}
                        type="flex"
                        justify="start"
                        align="middle"
                      >
                        <Col span={24}>
                          <span
                            style={{
                              float: 'right',
                              marginTop: '-4.3em',
                              marginBottom: '1.5em'
                            }}
                          >
                            <Button
                              onClick={() => {
                                const excel = new Excel();
                                excel
                                  .addSheet('Rigs')
                                  .addColumns(columns)
                                  .addDataSource([...rigs, totalsRow], {
                                    // optional formatting flags
                                  })
                                  .saveAs('Rigs.xlsx');
                              }}
                              style={{
                                zIndex: 999,
                                backgroundColor: '#EC8144',
                                color: 'white',
                                border: '1px solid #EC8144',
                                borderRadius: '3em',
                                marginLeft: '1em',
                                height: '3em',
                                width: '8em',
                                // marginTop: "1em",
                                float: 'right',
                                cursor: 'pointer'
                              }}
                            >
                              Export
                            </Button>

                            <StyledDatePicker
                              onChange={dates => {
                                if (!dates || dates.length === 0) {
                                  // user cleared the range
                                  this.setState({
                                    startDate: null,
                                    endDate: null
                                  });
                                } else {
                                  // normal pick
                                  this.setState({
                                    startDate: dates[0],
                                    endDate: dates[1]
                                  });
                                }
                              }}
                              value={[this.state.startDate, this.state.endDate]}
                              format={dateFormat}
                            />
                          </span>
                          <StyledTable
                            style={{ background: 'white' }}
                            rowKey="_id"
                            size="middle"
                            pagination={{
                              defaultPageSize: 10
                            }}
                            summary={() => (
                              <Table.Summary>
                                <Table.Summary.Row
                                  style={{
                                    backgroundColor: '#F0F3F9',
                                    fontWeight: 500,
                                    fontSize: 15
                                  }}
                                >
                                  <Table.Summary.Cell index={0} colSpan={3}>
                                    Cost per Meter
                                  </Table.Summary.Cell>
                                  <Table.Summary.Cell index={1} colSpan={1}>
                                    {costPerMeter.toLocaleString('en-US', {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                      useGrouping: true
                                    })}
                                  </Table.Summary.Cell>
                                  <Table.Summary.Cell index={2} colSpan={1} />
                                </Table.Summary.Row>

                                <Table.Summary.Row
                                  style={{
                                    backgroundColor: '#F0F3F9',
                                    fontWeight: 500,
                                    fontSize: 15
                                  }}
                                >
                                  <Table.Summary.Cell index={0} colSpan={3}>
                                    Total Meters
                                  </Table.Summary.Cell>
                                  <Table.Summary.Cell index={1} colSpan={1}>
                                    {totalMeters}
                                  </Table.Summary.Cell>
                                  <Table.Summary.Cell index={2} colSpan={1} />
                                </Table.Summary.Row>

                                <Table.Summary.Row
                                  style={{
                                    backgroundColor: '#F0F3F9',
                                    fontWeight: 500,
                                    fontSize: 15
                                  }}
                                >
                                  <Table.Summary.Cell index={0} colSpan={3}>
                                    Totals
                                  </Table.Summary.Cell>
                                  <Table.Summary.Cell index={1} colSpan={1}>
                                    {invoiceTotal.toLocaleString('en-US', {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                      useGrouping: true
                                    })}
                                  </Table.Summary.Cell>
                                  <Table.Summary.Cell index={2} colSpan={1} />
                                </Table.Summary.Row>
                              </Table.Summary>
                            )}
                            expandedRowRender={
                              window.innerWidth <= 420
                                ? record => (
                                    <Card
                                      size="small"
                                      title={record.itemCode}
                                      style={{ width: 300, marginLeft: -35 }}
                                    >
                                      <p>Brand: {record.brand}</p>
                                      <p>Description: {record.description}</p>
                                      <p>Quantity: {record.qty}</p>
                                      <p>Location: {record.location}</p>
                                      <p>Status: {record.status}</p>
                                    </Card>
                                  )
                                : null
                            }
                            dataSource={rigs}
                            onChange={this.handleSort}
                            onRow={record => {
                              if (parseInt(record.qty) === 0) {
                                return { style: { background: '#ffd3d3' } };
                              }
                            }}
                          >
                            {window.innerWidth > 420 ? (
                              <Column
                                {...this.getColumnSearchProps('currentRig')}
                                title="Rig Number"
                                dataIndex="currentRig"
                                key="currentRig"
                              />
                            ) : null}

                            {window.innerWidth > 420 ? (
                              <Column
                                title="Meters"
                                dataIndex="totalMeters"
                                key="totalMeters"
                                render={text => {
                                  return <span> {text ? text : 0}</span>;
                                }}
                              />
                            ) : null}
                            {window.innerWidth > 420 ? (
                              <Column
                                title="Cost Per Meter"
                                dataIndex="totalCostPerMeter"
                                key="totalCostPerMeter"
                                render={(text, record) => (
                                  <span>
                                    {record.totalCost && record.totalMeters
                                      ? (
                                          record.totalCost / record.totalMeters
                                        ).toLocaleString('en-US', {
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2
                                        })
                                      : '0.00'}
                                  </span>
                                )}
                              />
                            ) : null}
                            {window.innerWidth > 420 ? (
                              <Column
                                title="Rig Cost"
                                dataIndex="totalCost"
                                key="totalCost"
                                render={text => {
                                  return (
                                    <span>
                                      {text
                                        ? text.toLocaleString('en-US', {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2
                                          })
                                        : '0.00'}
                                    </span>
                                  );
                                }}
                              />
                            ) : null}

                            <Column
                              title="Actions"
                              width={200}
                              render={(text, stock) => (
                                <span>
                                  <Button
                                    style={{
                                      backgroundColor: '#EC8144',
                                      color: 'white',
                                      borderRadius: '3em'
                                    }}
                                    onClick={e => this.viewRig(stock)}
                                  >
                                    View Rig
                                  </Button>

                                  <Divider type="vertical" />
                                  {this.props.user.type === 'admin' ? (
                                    <DeleteFilled
                                      style={{
                                        backgroundColor: '#CFD5E3',
                                        color: 'white',
                                        padding: '0.5em',
                                        borderRadius: '3em'
                                      }}
                                      onClick={e => {
                                        this.setState({
                                          deleteVisible: true,
                                          deleteStock: stock
                                        });
                                      }}
                                    />
                                  ) : null}
                                </span>
                              )}
                            />
                          </StyledTable>
                        </Col>
                      </Row>
                    </TabPane>
                    <TabPane tab="Pits Drilled" key="2">
                      <Row
                        style={{
                          background: 'white',
                          borderRadius: 5,
                          marginTop: 0,
                          display:
                            !this.state.addStockVisible &&
                            !this.state.addBatchVisible
                              ? 'flex'
                              : 'none'
                        }}
                        type="flex"
                        justify="start"
                        align="middle"
                      >
                        <Col span={24}>
                          <span
                            style={{
                              float: 'right',
                              marginTop: '-4.3em',
                              marginBottom: '1.5em'
                            }}
                          >
                            <Button
                              onClick={() => {
                                const excel = new Excel();
                                excel
                                  .addSheet('Pits')
                                  .addColumns(pitsColumns)
                                  .addDataSource(
                                    rigs.flatMap(rig => {
                                      if (
                                        Array.isArray(rig.meterUpdates) &&
                                        rig.meterUpdates.length > 0
                                      ) {
                                        return rig.meterUpdates.flatMap(
                                          (update, index) => {
                                            if (
                                              moment(update.date).isBetween(
                                                this.state.startDate,
                                                this.state.endDate,
                                                'day',
                                                '[]'
                                              ) &&
                                              (this.state.selectedPitDrilled ===
                                                'all' ||
                                                update.pitDrilled ===
                                                  this.state.selectedPitDrilled)
                                            ) {
                                              return {
                                                ...rig,
                                                totalpitDrilled:
                                                  update.pitDrilled,
                                                totalMeters: update.meters,
                                                date: update.date,
                                                key: `${rig._id}_${index}`
                                              };
                                            } else {
                                              return [];
                                            }
                                          }
                                        );
                                      } else {
                                        return [];
                                      }
                                    }),
                                    {
                                      // str2Percent: true,
                                      //   str2num: true,
                                    }
                                  )
                                  .saveAs('Pits.xlsx');
                              }}
                              style={{
                                zIndex: 999,
                                backgroundColor: '#EC8144',
                                color: 'white',
                                border: '1px solid #EC8144',
                                borderRadius: '3em',
                                marginLeft: '1em',
                                height: '3em',
                                width: '8em',
                                // marginTop: "1em",
                                float: 'right',
                                cursor: 'pointer'
                              }}
                            >
                              Export
                            </Button>
                            <StyledDatePicker
                              onChange={dates => {
                                if (!dates || dates.length === 0) {
                                  // user cleared the range
                                  this.setState({
                                    startDate: null,
                                    endDate: null
                                  });
                                } else {
                                  // normal pick
                                  this.setState({
                                    startDate: dates[0],
                                    endDate: dates[1]
                                  });
                                }
                              }}
                              value={[this.state.startDate, this.state.endDate]}
                              format={dateFormat}
                            />
                          </span>
                          <Select
                            style={{
                              left: '11em',
                              top: '-3.6em',
                              position: ' absolute'
                            }}
                            value={this.state.selectedPitDrilled}
                            defaultValue="all"
                            onChange={value => {
                              const selectedPitDrilled = value;
                              const totalMetersSum = rigs
                                .flatMap(rig =>
                                  rig.meterUpdates
                                    .filter(update =>
                                      moment(update.date).isBetween(
                                        this.state.startDate,
                                        this.state.endDate,
                                        'day',
                                        '[]'
                                      )
                                    )
                                    .filter(update =>
                                      selectedPitDrilled === 'all'
                                        ? true
                                        : update.pitDrilled ===
                                          selectedPitDrilled
                                    )
                                    .reduce(
                                      (sum, update) => sum + update.meters,
                                      0
                                    )
                                )
                                .reduce((sum, meters) => sum + meters, 0);
                              this.setState({
                                selectedPitDrilled,
                                totalMetersSum
                              });
                            }}
                          >
                            <Option value="all">All Pits</Option>
                            {Array.from(
                              new Set(
                                rigs.flatMap(rig =>
                                  rig.meterUpdates
                                    ?.filter(update =>
                                      moment(update.date).isBetween(
                                        this.state.startDate,
                                        this.state.endDate,
                                        'day',
                                        '[]'
                                      )
                                    )
                                    ?.map(update => update.pitDrilled)
                                )
                              )
                            ).map((pitDrilled, index) => (
                              <Select.Option key={index} value={pitDrilled}>
                                {pitDrilled}
                              </Select.Option>
                            ))}
                            {!rigs || (rigs.length === 0 && null)}
                          </Select>
                          <StyledTable
                            style={{ background: 'white' }}
                            rowKey={(record, index) => `${record._id}_${index}`}
                            size="middle"
                            pagination={{
                              defaultPageSize: 7
                            }}
                            dataSource={rigs.flatMap(rig => {
                              if (
                                Array.isArray(rig.meterUpdates) &&
                                rig.meterUpdates.length > 0
                              ) {
                                return rig.meterUpdates.flatMap(
                                  (update, index) => {
                                    if (
                                      moment(update.date).isBetween(
                                        this.state.startDate,
                                        this.state.endDate,
                                        'day',
                                        '[]'
                                      ) &&
                                      (this.state.selectedPitDrilled ===
                                        'all' ||
                                        update.pitDrilled ===
                                          this.state.selectedPitDrilled)
                                    ) {
                                      return {
                                        ...rig,
                                        totalpitDrilled: update.pitDrilled,
                                        totalMeters: update.meters,
                                        date: update.date,
                                        key: `${rig._id}_${index}`
                                      };
                                    } else {
                                      return [];
                                    }
                                  }
                                );
                              } else {
                                return [];
                              }
                            })}
                            onChange={this.handleSort}
                            onRow={record => {
                              if (parseInt(record.qty) === 0) {
                                return { style: { background: '#ffd3d3' } };
                              }
                            }}
                            summary={() => (
                              <Table.Summary>
                                <Table.Summary.Row
                                  style={{
                                    backgroundColor: '#F0F3F9',

                                    fontWeight: 500,
                                    fontSize: '15px'
                                  }}
                                >
                                  <Table.Summary.Cell index={1} colSpan={2}>
                                    Total Meters
                                  </Table.Summary.Cell>

                                  <Table.Summary.Cell index={4} colSpan={3}>
                                    {this.state.totalMetersSum != 0
                                      ? this.state.totalMetersSum
                                      : totalMeters}{' '}
                                    {/* Use the updated totalMetersSum state variable */}
                                  </Table.Summary.Cell>
                                </Table.Summary.Row>
                              </Table.Summary>
                            )}
                          >
                            <Column
                              {...this.getColumnSearchProps('currentRig')}
                              title="Rig Number"
                              dataIndex="currentRig"
                              key="currentRig"
                            />
                            <Column
                              {...this.getColumnSearchProps('totalpitDrilled')}
                              title="Pit Drilled"
                              dataIndex="totalpitDrilled"
                              key="totalpitDrilled"
                              render={text => {
                                return text ? text : 'None';
                              }}
                            />
                            <Column
                              title="Meters"
                              dataIndex="totalMeters"
                              key="totalMeters"
                              render={text => {
                                return <span> {text ? text : 0}</span>;
                              }}
                            />
                            {window.innerWidth > 420 ? (
                              <Column
                                {...this.getColumnSearchProps('date')}
                                title="Date"
                                dataIndex="date"
                                key="date"
                                render={text => {
                                  const formattedDate = moment(text).format(
                                    'YYYY-MM-DD HH:mm:ss'
                                  );
                                  return formattedDate;
                                }}
                              />
                            ) : null}
                          </StyledTable>
                        </Col>
                      </Row>
                    </TabPane>
                  </Tabs>
                </Col>
              </Row>
              {/* )} */}
            </Spin>
          </div>
          <Modal
            title={'Delete stock'}
            visible={this.state.deleteVisible}
            onOk={this.handleDeleteStock}
            onCancel={this.cancelDelete}
            okText="Accept"
            cancelText="Cancel"
          >
            <span>
              {' '}
              Are you sure you want to delete this rig{' '}
              {/* {this.props.stock.map(stock => ( */}
              {/* <span>{stock.currentRig}</span> */}
              {/* ))} */}
            </span>
          </Modal>
        </div>
      );
    } else {
      return (
        <div>
          <Row
            type="flex"
            justify="start"
            align="middle"
            style={{
              textAlign: 'left',
              maxWidth: '90em',
              margin: 'auto',
              marginTop: '2em'
            }}
          >
            <Col
              xs={12}
              md={24}
              style={{ marginLeft: '-0.8em', marginTop: '-1.3em' }}
            >
              <Button
                type="primary"
                shape="round"
                onClick={e =>
                  this.setState({ viewRig: false, currentRig: undefined })
                }
                size="large"
                style={{
                  zIndex: 999,
                  backgroundColor: '#EC8144',
                  color: 'white',
                  border: '1px solid #EC8144',
                  borderRadius: '3em',
                  marginLeft: '1em',
                  height: '3em',
                  width: '7em',
                  // marginTop: "1em",
                  float: 'left',
                  cursor: 'pointer'
                }}
              >
                Back
              </Button>
              <span
                style={{
                  fontWeight: 500,
                  fontSize: 20,
                  color: 'black',
                  marginLeft: 10,
                  marginTop: '0.5em',
                  lineHeight: '1.2em',
                  float: 'left',
                  fontFamily: 'Roboto'
                }}
              >
                Rig nr: {currentRig.currentRig} -{' '}
                <span style={{ color: 'rgb(236, 129, 68)' }}>
                  {' '}
                  Total Tools:{' '}
                  {currentRig.cost && <span>{currentRig.cost.length}</span>}
                </span>
              </span>{' '}
              <span
                style={{
                  fontWeight: 500,
                  fontSize: 20,
                  float: 'right',
                  color: 'black',
                  marginTop: '0.5em',
                  fontFamily: 'Roboto'
                }}
              >
                <Button
                  onClick={() => {
                    const excel = new Excel();

                    // 1) Safely grab and filter out “Reissued”
                    const tools = Array.isArray(currentRig?.cost)
                      ? currentRig.cost
                      : [];
                    const filteredTools = tools;

                    // 2) Compute your total (e.g. sum of `price`)
                    const totalPrice = filteredTools.reduce(
                      (sum, t) => sum + Number(t.price || 0),
                      0
                    );

                    // 3) Build a totalsRow matching your columns’ dataIndex
                    //    Suppose your columns are like:
                    //      { title: 'Serial', dataIndex: 'toolSerial' }
                    //      { title: 'Date',   dataIndex: 'date'       }
                    //      { title: 'Price',  dataIndex: 'price'      }
                    //      { title: 'Status', dataIndex: 'status'     }
                    //
                    const totalsRow = {
                      toolSerial: 'Total', // under the “Serial” column
                      date: null, // blank date cell
                      price: totalPrice, // your computed sum
                      status: '', // blank status cell
                      key: 'totals-row'
                    };

                    // 4) Export the filtered rows + the totals row
                    excel
                      .addSheet('Rig Tools')
                      .addColumns(currentRigColumns)
                      .addDataSource([...filteredTools, totalsRow], {
                        // any formatting flags
                      })
                      .saveAs('Rig Tools.xlsx');
                  }}
                  style={{
                    zIndex: 999,
                    backgroundColor: '#EC8144',
                    color: 'white',
                    border: '1px solid #EC8144',
                    borderRadius: '3em',
                    marginLeft: '1em',
                    height: '3em',
                    width: '8em',
                    float: 'right',
                    cursor: 'pointer'
                  }}
                >
                  Export
                </Button>

                <StyledDatePicker
                  onChange={dates => {
                    if (!dates || dates.length === 0) {
                      // user cleared the range
                      this.setState({ startDate: null, endDate: null });
                    } else {
                      // normal pick
                      this.setState({ startDate: dates[0], endDate: dates[1] });
                    }
                  }}
                  value={[this.state.startDate, this.state.endDate]}
                  format={dateFormat}
                />
              </span>
              <br />
            </Col>
            <Col
              xs={12}
              md={12}
              style={{
                marginTop: '-1em',
                textAlign: 'right'
              }}
            />
          </Row>
          <div style={{ maxWidth: '90em', margin: 'auto' }}>
            <Spin spinning={this.state.loading}>
              {/* ) : ( */}
              <Row
                style={{
                  background: 'white',
                  borderRadius: 5,
                  marginTop: 20,
                  display:
                    !this.state.addStockVisible && !this.state.addBatchVisible
                      ? 'flex'
                      : 'none'
                }}
                type="flex"
                justify="start"
                align="middle"
              >
                <Col span={24}>
                  <StyledTable
                    // columns={columns}
                    rowClassName={record =>
                      record.status === 'Reissued' ? 'red-row' : ''
                    } // Add rowClassName and conditionally apply 'red-row' class
                    dataSource={costDataClone}
                    scroll={{
                      // x: 1500,
                      y: 600
                    }}
                    pagination={{
                      defaultPageSize: 10
                    }}
                  >
                    <Column
                      title="Serial Nr."
                      dataIndex="toolSerial"
                      key="toolSerial"
                    />

                    <Column
                      {...this.getColumnSearchProps('serial')}
                      title="Stock Nr."
                      dataIndex="serial"
                      key="serial"
                    />
                    {window.innerWidth > 420 ? (
                      <Column
                        {...this.getColumnSearchProps('size')}
                        title="Tool Type"
                        width={120}
                        dataIndex="size"
                        key="size"
                      />
                    ) : null}
                    {window.innerWidth > 420 ? (
                      <Column
                        //{...this.getColumnSearchProps("size")}
                        title="Description"
                        dataIndex="description"
                        key="description"
                      />
                    ) : null}

                    {window.innerWidth > 420 ? (
                      <Column
                        //{...this.getColumnSearchProps("status")}
                        title="Status"
                        dataIndex="status"
                        key="status"
                        render={status => {
                          switch (status) {
                            case 'New':
                              return this.renderStatus('New', '#4BED5B');
                            case 'Used':
                              return this.renderStatus('Used', 'grey');
                            case 'Out':
                              return this.renderStatus('Out', '#FF8F28');
                            case 'Sharp':
                              return this.renderStatus('Sharp', '#EDAC4B');
                            case 'Lost':
                              return this.renderStatus('Lost', '#D4D4D4');
                            case 'Damaged':
                              return this.renderStatus('Damaged', '#EE4C4C');
                            case 'None':
                              return this.renderStatus('None', 'lightgrey');
                            case 'Reissued':
                              return this.renderStatus('Reissued', 'red');
                            default:
                              return this.renderStatus(
                                'No Status',
                                'lightgrey'
                              );
                          }
                        }}
                      />
                    ) : null}
                    {window.innerWidth > 420 ? (
                      <Column
                        {...this.getColumnSearchProps('date')}
                        title="Date"
                        dataIndex="date"
                        key="date"
                        render={text => {
                          const formattedDate = moment(text).format(
                            'YYYY-MM-DD HH:mm:ss'
                          );
                          return formattedDate;
                        }}
                      />
                    ) : null}
                    {window.innerWidth > 420 ? (
                      <Column
                        //{...this.getColumnSearchProps("size")}
                        title="Price"
                        dataIndex="price"
                        key="price"
                        render={text => {
                          return (
                            <span>
                              {parseFloat(text).toLocaleString('en-US', {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                              })}
                            </span>
                          );
                        }}
                      />
                    ) : null}
                  </StyledTable>
                </Col>
              </Row>
            </Spin>
          </div>
        </div>
      );
    }
  }
}

export default Stock;
